import FileDownload from "js-file-download";
import moment from "moment";

export async function fileDownloadHandler(title, data, isCSV = true) {
  const date = moment().format("YYYY-MM-DD");
  const forceExcelUTF8 = "\ufeff";
  const resultantTitle = `${isCSV ? `${title}_${date}.csv` : title}`;
  FileDownload((isCSV ? forceExcelUTF8 : "") + data, `${resultantTitle}`);
}
